import backendHttpClient from '@services/_httpClient/backend.http-client';

import { type CreateSessionPayload } from './dtos/create.dto';
import { type SessionRepository } from './repository';
import type {
  CreateSessionOutput,
  CreateSessionResponse,
} from './types/create.type';
import type {
  GetSessionInfoOutput,
  GetSessionInfoResponse,
} from './types/getInfo.type';

class SessionService implements SessionRepository {
  public async create(
    payload: CreateSessionPayload,
  ): Promise<CreateSessionOutput> {
    const response = await backendHttpClient.post<
      CreateSessionResponse,
      CreateSessionPayload
    >({
      path: 'collaborators/sessions',
      body: {
        email: payload.email,
        password: payload.password,
      },
    });
    const output: CreateSessionOutput = {
      token: response.data.token,
      refreshToken: response.data.refresh_token,
    };
    return output;
  }

  public async getInfo(): Promise<GetSessionInfoOutput> {
    const response = await backendHttpClient.get<GetSessionInfoResponse>({
      path: 'collaborators/sessions',
    });
    const output: GetSessionInfoOutput = {
      email: response.data.email,
      id: response.data.id,
      name: response.data.name,
      crm: response.data.crm,
      phone: response.data.phone,
      document: response.data.document,
      documents: response.data.documents,
      isActive: response.data.is_active,
      medicalSpecialties: response.data.medical_specialties.map(item => ({
        id: item.id,
        medicalSpecialtyId: item.medical_specialty_id,
        name: item.name,
        status: item.status,
      })),
    };
    return output;
  }
}

export const sessionService = new SessionService();
